import { render, staticRenderFns } from "./InformationBar.vue?vue&type=template&id=5e8dcfa6&"
import script from "./InformationBar.vue?vue&type=script&lang=js&"
export * from "./InformationBar.vue?vue&type=script&lang=js&"
import style0 from "./InformationBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports